import sk_vuetify from "vuetify/src/locale/sk.ts";
import sk_vee from "vee-validate/dist/locale/sk";

let lang = {
  lang: {
    iso: "sk-SK",
    decimal_separator: ","
  },

  common: {
    position: "Pozícia",
    driver: "Vodič",
    ride: "Jazda",
    vehicle_filter: "Filter vozidiel",
    remaining: "zostáva",
    date: "Dátum",
    time: "Čas",
    currency: "Mena",
    service_is: "za",
    service_over: "cez",
    select_all_filtered_itms: "Vybrať všetky fitrované položky",
    select_none_filtered_itms: "Odstrániť všetky filtrované položky",
    vehicle: {
      vehicle: "Sledovať vozidlo",
      history: "História",
      logbook: "Kniha jázd",
      refueling: "Tankovanie",
      state_ok: "komunikuje",
      state_fail: "nekomunikuje"
    },
    or: "alebo",
    last_timestamp: "Čas poslednej komunikácie",
    vehicle_ids: "Identifikátory vozidla (ID vozidla, a seriové číslo zariadenia)",
    fast_filter: "Rýchly filter",
    empty_list_with_add: "Zoznam je prázdny.<br/>Tlačítkom <b>Pridať</b> vložíte novú identifikáciu.",
    door: "dvere",
    panic: "PANIC"
  },

  main_menu: {
    actions: {
      company_select: "Firmy",
      groupset_select: "Skupina",
      map: "Mapa",
      map_preview: "Prehľad vozidiel",
      plan: "Plán zákaziek",
      vehicle_select: "Vybrať vozidlo",
      find: "Hľadať vozidlo",
      refueling: "Vložiť tankovanie",
      vehicles: "Vozidlá",
      persons: "Osoby",
      groupsets: "Skupiny",
      contracts: "Zakázky",
      subjects: "Spoločnosti",
      sharings: "Zdieľanie polohy",
      companies: "Firmy"
    },
    reports: {
      title: "Výkazy"
    },
    logout: "Odhlásiť"
  },

  map: {
    tooltip: {
      right_panel: "Zobraziť/skryť pravý panel",
      refresh: "Aktualizovať stav vozidiel. Stav sa automaticky aktualizuje každú minútu.",
      zoom_in: "Priblížiť",
      zoom_out: "Oddialiť",
      default_view: "Začiatočné zobrazenie mapy",
      map_layer: "Mapový podklad",
      company_current: "Vybraná firma: ",
      control: {
        prev_week: "Predchádzajúci týždeň",
        next_week: "Nasledujúci týždeň",
        prev_day: "Predchádzajúci deň",
        next_day: "Nasledujúci deň",
        toggle_graph: "Zobraziť/skryť graf",
        options: "Parametre zobrazenia"
      },
      vehicle_popup: {
        tachograph_day: "Denná doba jazdy",
        tachograph_week: "Týždenná doba jazdy",
        invalid_tachograph_data: "Neaktuálne dáta tachografu"
      }
    },
    title: {
      base: "{name}",
      satellite: "{name} (letecká)",
      traffic: "{name} (premávka)"
    },
    panel: {
      tooltip: {
        vehicle: "Detail vozidla",
        history: "História vozidla",
        logbook: "Kniha jázd",
        refueling: "Tankovanie",
        events: "Udalosti vozidla",
        contracts: "Zákazky vozidla",
        service: "Údržba",
        close: "Späť na online"
      },
      online: {
        action: {
          logbook: "Kniha jázd",
          vehicle_update: "Úprava prevádzkových parametrov",
          vehicle_edit: "Úprava vozidla"
        },
        tooltip: {
          show_hide: "Zobraziť/skryť vozidlo na mape",
          keep_on_map: "Udržiavať vybrané vozidlá viditeľné na mape",
          vehicle: "Zobraziť vozidlo",
          logbook: "Zobraziť knihu jázd",
          history: "Zobraziť históriu vozidla",
          show_all: "Zobraziť všetky vyfiltrované vozidlá",
          hide_all: "Skryť všetky vyfiltrované vozidlá",
          update: "Úprava prevádzkových parametrov",
          edit: "Upraviť vozidlo",
          log: "Zobraziť log vozidla",
          more: "Ďalšie operácie"
        },
        service: "servis"
      },
      history: {
        column: {
          from_ts: "Od",
          to_ts: "Do",
          duration: "Doba",
          from: "Odkiaľ",
          to: "Kam",
          type_driver: "Typ jazdy • vodič • poradie",
          odometer: "Tacho.",
          distance: "Vzdá.",
          consumption: "Spotreba"
        },
        menu: {
          cancel: "Zrušiť výber",
          print_graph: "Vytlačiť graf",
          export_graph: "Export do PDF"
        },
        ride_menu: {
          "select": "Vybrať jazdu",
          "update": "Upraviť jazdu"
        },
        show_all: "Zobraziť aj nulové jazdy",
        graph: {
          altitude: {
            title: "Nadmorská výška",
            axle: "Nadmorská výška [m]",
            unit: "m.n.m"
          },
          speed: {
            title: "Rýchlosť",
            axle: "Rýchlosť [km/h]",
            unit: "km/h"
          },
          km: {
            title: "Stav tachometra",
            axle: "Tachometer [km]",
            unit: "km"
          },
          tank: {
            title: "Stav nadrží",
            axle: "Stav nadrží [l]",
            unit: "l"
          },
          weight: {
            title: "Zaťaženie náprav",
            axle: "Zaťaženie náprav [t]",
            unit: "t"
          },
          rpm: {
            title: "Otáčky",
            axle: "Otáčky [rpm]",
            unit: "rpm"
          },
          temp1: {
            title: "Teplota 1",
            axle: "Teplota 1 [℃]",
            unit: "℃"
          },
          temp2: {
            title: "Teplota 2",
            axle: "Teplota 2 [℃]",
            unit: "℃"
          }
        }
      },
      logbook: {
        title: "Kniha jázd",
        tooltip: {
          report_logbook: "Zobraziť knihu jázd",
          report_performance: "Zobraziť výkon vozidla",
          report_machine_performance: "Zobraziť výkon stroja"
        },
        column: {
          from_ts: "Od",
          to_ts: "Do",
          from: "Odkiaľ",
          to: "Kam",
          odometer: "Tachometer",
          distance: "Vzdialenosť",
          tank_level: "Nádrže",
          tank_diff: "Zmena"
        },
        ride_menu: {
          "select": "Vybrať jazdu",
          "update": "Upraviť jazdu"
        }
      },
      refueling: {
        title: "Tankovanie",
        tooltip: {
          report_refueling: "Zobraziť výkaz tankovania"
        },
        column: {
          ts: "Čas",
          place: "Miesto",
          driver: "Vodič",
          quantum_m: "Množstvo",
          quantum_d: "Dok. množstvo",
          amount: "Cena"
        },
        ride_menu: {
          "select": "Vybrat jízdu",
          "update": "Upravit jízdu"
        }
      },
      service: {
        title: "Údržba",
        tooltip: {
          add_plan: "Vytvoriť nový plán údržby",
          add_service: "Vložiť údržbu"
        },
        column: {
          plan: {
            name: "Plán",
            repetition: "Opakovanie",
            next: "Nastane"
          },
          service: {
            name: "Údržba",
            date: "Dátum",
            state: "Stav"
          }
        },
        plan_menu: {
          select: "Vybrať plán",
          update: "Upraviť plán",
          delete: "Vymazať plán",
          addservice: "Pridať údržbu"
        },
        service_menu: {
          update: "Upraviť údržbu",
          delete: "Vymazať údržbu"
        },
        delete_plan_msg: "Naozaj chcete vymazať plán: <b>{plan}</b>?",
        delete_with: "Vymazať vrátane údržby",
        delete_service_msg: "Naozaj chcete vymazať údržbu: <b>{service}</b>?"
      },
      events: {
        title: "Udalosti",
        column: {
          ts: "Čas",
          event: "Udalosť",
          state: "Stav",
          person: "Osoba"
        },
        context_menu: {
          "select": "Zobraziť udalosť na mape"
        }
      },
      contracts: {
        title: "Zakázky",
        column: {
          name: "Názov",
          subject: "Organizácia",
          from: "Od",
          to: "Do",
          distance: "Vzdialenosť",
          duration: "Doba",
          amount: "Cena",
          amount_km: "Cena za km"
        },
        contract_menu: {
          "select": "Zobraziť na mape",
          "update": "Upraviť zákazku"
        },
        noride: "Žiadna nameraná jazda"
      },
      vehicle: {
        base: {
          name: "Názov",
          type: "Typ",
          location: "Pozícia",
          timestamp: "Čas",
          speed: "Rýchlosť",
          odometer: "Tachometer",
          driver_quality: "Moment. kval. riadenia",
          enginehours: "Stav motohodin",
          coords: "Súradnice",
          coords_google_map: "Otvoriť v Google maps",
          coords_google_clipboard: "Kopirovať URL do schránky",
          vcc: "Stav batérie",
          temp1: "Teplota 1",
          temp2: "Teplota 2",
          toservice: "Servis za"
        },
        info: {
          title: "Informácie o vozidle",
          numeric_plate: "ŠPZ",
          vin: "VIN",
          manufacture_year: "Rok výroby",
          enorm: "Hom. emisií",
          category: "Kategória",
          type_design: "Typ. označenie",
          device_code: "Zariadenie",
          id: "ID"
        },
        "service-plans": {
          title: "Údržba"
        },
        ride: {
          last_title: "Posledná jazda",
          active_title: "Aktuálna jazda",
          type: "Typ",
          state: "Stav",
          from: "Odkiaľ",
          to: "Kam",
          distance: "Vzdialenosť",
          enginehours: "Motohodiny",
          elevation: "Prevýšenie",
          driver_quality: "Kvalita riadenia",
          consumption: "Spotreba paliva",
          max_speed: "Max. rýchlosť",
          over_speed: "Prekročenie rýchlosti",
          motor_idle: "Motor naprázdno",
          axle_load: "Celkové zaťaženie",
          vcc: "Stav batérie",
          driver: "Vodič",
          tanks: "Nádrže",
          note: "Poznámka"
        },
        tanks: {
          title: "Jednotlivé nádrže",
          tank1: "Nádrž 1",
          tank2: "Nádrž 2",
          tank3: "Nádrž 3",
          tank4: "Nádrž 4"
        },
        axleweight: {
          title: "Zaťaženie náprav"
        },
        tachograph: {
          history: "História",
          history_tooltip: "Zobraziť históriu tachografu",
          title: "Tachograf",
          card_id: "Číslo karty",
          last_update: "Aktualizácia",
          activity: "Činnosť",
          day_drive: "Denná jazda",
          day_rest: "Denný odpočinok",
          week_drive: "Týždenná jazda",
          week_rest: "Týždenný odpočinok",
          twoweeks_drive: "14-denná jazda"
        },
        noactive_suffix: "(neaktuálne)"
      }
    }
  },

  "map-preview": {
    size2small: "Zmenšiť dlaždice",
    size2large: "Zväčšiť dlaždice",
    row10: "Obmedzenie na 10 riadkov",
    rowall: "Zobraziť všetky vybrané vozidlá"
  },

  // rozhraní pro zobrazení a editaci objektu
  data: {
    toolbar: {
      new_record: "Nový záznam",
      record_store: "Uložiť záznam",
      record_cancel: "Zrušiť úpravu záznamu",
      view_cancel: "Späť na prehľad",
      actions: "Ďalšie operácie nad záznamom"
    },
    item: {
      new_item: "nový záznam",
      vehicles: "Vozidlá",
      persons: "Osoby",
      "special-accesses": "Špeciálne prístupy",
      groupsets: "Skupiny",
      sharings: "Zdieľanie polohy",
      companies: "Firmy",
      contracts: "Zakázky",
      subjects: "Spoločnosti",
      vehicle: "Vozidlo",
      person: "Osoba",
      "special-access": "Špeciálny prístup",
      groupset: "Skupina",
      contract: "Zákazka",
      subject: "Spoločnosť",
      sharing: "Zdieľanie polohy",
      company: "Firma",
      deviceConnections: "Pripojené vozidlá",
      apiConnections: "Pripojenie užívateľa"
    }
  },

  // pohledy a editace záznamů
  view: {
    leave_msg: "Chcete naozaj zrušiť úpravu záznamu. Všetky neuložené zmeny budú stratené.",
    delete_msg: "Naozaj chcete vymazať záznam?<br/>Mazanie môže trvať dlho.",
    company: {
      group: {
        base: "Základné parametre",
        perms: "Oprávnenie"
      },
      name: "Názov",
      code: "Kód",
      country: "Štát",
      active: "Platná firma",
      module_contracts: "Modul zákaziek"
    },
    person: {
      group: {
        base: "Základné parametre",
        ids_perms: "Oprávnenie a identifikácia",
        vehicles: "Povolené vozidlá",
        persons: "Povolené osoby",
        companies: "Firmy"
      },
      first_name: "Meno",
      last_name: "Priezvisko",
      login: "Prihlasovacie meno",
      password: "Heslo",
      admin: "Administrátor firmy",
      dispatcher: "Dispečer",
      driver: "Vodič",
      active: "Platná osoba",
      viewall: "Vidí všetko",
      role_title: "Rola",
      identification_title: "Identifikácia",
      add_identification: "Pridať",
      tooltip: {
        id_add: "Pridať identifikáciu",
        id_remove: "Vymazať identifikáciu"
      }
    },
    "special-access": {
      group: {
        base: "Základné parametre",
        vehicles: "Pridelené vozidlá"
      },
      first_name: "Meno",
      last_name: "Priezvisko",
      access: "Typ prístupu",
      login: "Prihlasovacie meno",
      password: "Heslo",
      active: "Platný prístup",
      add_vehicle: "Pridať",
      tooltip: {
        remove_vehicle: "Odstrániť vozidlo"
      }
    },
    groupset: {
      group: {
        base: "Základné parametre",
        permission: "Oprávněné osoby (mimo administrátory)",
        vehicles: "Vozidla",
        persons: "Osoby"
      },
      name: "Názov",
      note: "Poznámka"
    },
    contract: {
      group: {
        base: "Základné parametre",
        plan: "Plán"
      },
      vehicle: "Vozidlo",
      name: "Názov",
      from_ts: "Začína",
      to_ts: "Končí",
      from_place: "Odkiaľ",
      to_place: "Kam",
      btn_plan: "Plánovať",
      btn_paste: "Vložiť",
      btn_clear: "Vymazať"
    },
    subject: {
      group: {
        base: "Základné parametre",
        contacts: "Kontakty"
      },
      country: "Krajina",
      name: "Názov",
      id: "Identifikácia (IČ)",
      vat_number: "Daňová identifikácia (DIČ)",
      note: "Poznámka",
      active: "Organizácia je aktívna",
      add_contact: "Pridať",
      flag_registered: "registrovaný",
      flag_billing: "fakturačný",
      flag_communication: "komunikačný",
      tooltip: {
        update_contact: "Upraviť kontakt",
        remove_contact: "Odebrat kontakt",
        search: "Vyhľadať spoločnosť podľa identifikácie"
      }
    },
    sharing: {
      group: {
        base: "Základné parametre",
        flags: "Voliteľné informácie",
        vehicles: "Zdieľané vozidlá"
      },
      copy: "Kopírovat",
      hash_code: "Prístupový kód",
      valid_from: "Platné od",
      valid_to: "Platné do",
      flag_paninc: "Zobrazovať PANIC stav",
      flag_cargo_door: "Zobrazovať stav dverí nákladu",
      note: "Poznámka",
      add_vehicle: "Pridať",
      tooltip: {
        remove_vehicle: "Odobrať vozidlo"
      }
    },
    vehicle: {
      group: {
        base: "Základné parametre",
        administration: "Administatívne údaje",
        technical: "Technické parametre",
        device: "Zariadenie",
        measure: "Parametre pre meranie",
        ids_tanks: "Identifikácia a nádrže",
        tank_title: "Nádrže"
      },
      name: "Názov",
      numeric_plate: "ŠPZ",
      type: "Typ",
      state: "Stav",
      // technické parametry
      consumption_km: "Priemerná spotreba na l/100km",
      consumption_eh: "Priemerná spotreba na l/h",
      type_design: "Typové označenie",
      category_code: "Kategória",
      axles: "Nápravy (tučne - celková hmotnosť)",
      weight: "Celková hmotnosť (v kg)",
      // adminsitrativní údaje
      vin: "VIN",
      technical_licence: "Číslo technického preukazu",
      emission_report: "Číslo emisného protokolu",
      euro_norm_code: "Homologácia emisií podľa EÚ",
      manufacture_year: "Rok výroby",
      person: "Zodpovedná osoba",
      // device
      device_type: "Typ komunikačného zariadenia",
      code: "Jednoznačná identifikácia zariadenia",
      serialnum: "Sériové číslo",
      install_date: "Nainštalované",
      installer: "Nainštaloval",
      detectbymotion: "Detekcia jazdy pomocou pohybu",
      detectspeed: "Rýchlosť od ktorej sa detekuje jazda v km/h",
      km_gps: "Vzdialenosť sa meria a tachograf počíta podľa GPS",
      join_ival: "Maximálny interval čas pre spojenie v sekundách",
      split_ival: "Minimálny interval s pre rozdelenie jázd v sekundách",
      store_ival: "Minimálny interval ukladania pozícií mimo jazdu alebo pokiaľ stojí vozidlo na mieste (0 - všetko, záporné - zakázané)",
      inactive_tm: "Čas po kterom je vozidlo vedené ako nekomunikujúce (v minútach)",
      m_rpm: "Zaznamenávať otáčky",
      m_service_km: "Použiť vzdialenosť do servisu",
      m_service_date: "Použiť čas do servisu",
      // device - dynamické parametry
      pvalues: {
        motorbit: "Pin pre detekciu motora",
        motorbit_none: "Nedetekovať",
        motorbit_pin5: "Pin 5",
        motorbit_pin7: "Pin 7",
        detect_ridetype: "Prepínanie jazdy",
        detect_ridetype_0: "Nevyčítať",
        detect_ridetype_30: "Služobná/súkromná (ADC3)",
        detect_ridetype_31: "Služobná/nakládka-vykládka (ADC3)",
        detect_ridetype_50: "Služobná/súkromná (ADC5)",
        detect_ridetype_51: "Služobná/nakládka-vykládka (ADC5)",
        none: "Nevyčítať",
        temperature1: "Teplota 1",
        temperature2: "Teplota 2",
        din: "Digitalný vstup {0}",
        panic: "Tlačidlo PANIC",
        cargo_door: "Dvere nákladového priestoru"
      },
      // parametry pro měření
      km_start: "Počiatočná hodnota tachomeru (v km)",
      eh_start: "Počiatočná hodnota motohodín (v h)",
      min_tank_change: "Minimálna zmena paliva v litroch",
      consumption_min_km: "Štandardné minimum spotreby v l na 100km",
      consumption_max_km: "Štandardné maximum spotreby v l na 100km",
      consumption_min_eh: "Štandardné minimum spotreby v l na mh",
      consumption_max_eh: "Štandardné maximum spotreby v l na mh",
      use_last_driver: "Použiť posledného prihláseného vodiča",
      driver: "Priradený vodič k vozidlu",
      rpm_optimum: "Optimálne otáčky",
      rpm_max: "Maximálne otáčky",
      speed_max: "Maximálna rýchlosť (pre sledovanie)",
      max_temperature_liquid: "Maximálna teplota chladiacej kvapaliny",
      ft_day: "Deň v mesiaci, kedy sa tankuje do plna",
      service_km: "Stav tachometra pre ďalší pravidelný servis",
      service_eh: "Stav motohodín pre ďalší pravidelný servis",
      service_day: "Dátum pre ďalší pravidelný servis",
      mot_date: "Dátum pre nasledujúce STK",
      tachograph_check_date: "Dátum na kontrolu tachografu",
      undefined_tank: "Nedefinovaná",
      suitable_conditions: "vhodné podmienky",
      tooltip: {
        tank_update: "Upraviť nádrž"
      }
    },
    plan: {
      title: "Plán zákaziek",
      "show-all": "Zobraziť aj vozidlá čo nemajú žiadnu zákazku",
      "zoom-month": "Zobraziť celý mesiac",
      "zoom-in": "Zväčšiť časovú os",
      "zoom-out": "Zmenšiť časovú os",
      save: "Uložiť plán do súboru",
      "save-png": "Uložiť ako obrázok (PNG)",
      "save-pdf": "Uložiť ako dokument (PDF)",
      "context-menu": {
        vehicle: {
          "map-vehicle": "Zobraziť vozidlo",
          "map-contracts": "Zákazky vozidla",
          "report-logbook": "Kniha jázd",
          "report-performance": "Výkon vozidla"
        },
        contract: {
          "map": "Zobraziť zákazku na mape",
          "edit": "Upraviť zákazku"
        }
      }
    }
  },

  // tabulky záznamů
  table: {
    vehicles: {
      header: {
        numeric_plate: "ŠPZ",
        name: "Názov",
        type: "Typ",
        imei: "IMEI",
        installDate: "Nainštalované",
        state: "Stav"
      },
      "context-menu": {
        "map": "Zobraziť na mape",
        "history": "Zobraziť históriu",
        "logbook": "Kniha jázd",
        "refueling": "Tankovanie",
        "events": "Udalosti",
        "contracts": "Zakázky",
        "service": "Údržba",
        "report-logbook": "Výkaz - Kniha jázd",
        "report-performance": "Výkaz - Výkon vozidla",
        "report-machine-performance": "Výkaz - Výkon stroja",
        "reset-panic": "Zrušiť PANIC"
      }
    },
    persons: {
      header: {
        name: "Meno",
        login: "Prihlasovacie meno",
        roles: "Rola",
        ids: "Identifikácia"
      },
      "context-menu": {
        "report-tachograph": "Výkaz - Tachograf",
        "report-travel-expenses": "Výkaz - Cestovné náhrady",
        "person-export": "Pridať osobu do inej firmy"
      }
    },
    "special-accesses": {
      header: {
        name: "Meno",
        login: "Prihlasovacie meno",
        access: "Typ prístupu"
      }
    },
    groupsets: {
      header: {
        name: "Názov",
        note: "Poznámka"
      }
    },
    sharings: {
      header: {
        hash: "Kód",
        from: "Platnosť od",
        to: "Platnosť do",
        note: "Poznámka"
      },
      "context-menu": {
        "copy-code": "Skopírovať kód do schránky",
        "copy-url": "Skopírovať URL do schránky"
      }
    },
    contracts: {
      header: {
        vehicle: "Vozidlo",
        name: "Názov",
        subject: "Organizácia",
        place_from: "Odkiaľ",
        place_to: "Kam",
        from: "Od",
        to: "Do",
        distance: "Vzdialenosť",
        duration: "Doba",
        amount: "Cena",
        amount_km: "Cena za km"
      },
      "context-menu": {
        "show-on-map": "Zobraziť na mape"
      }
    },
    subjects: {
      header: {
        name: "Názov",
        country: "Krajina",
        id: "Identifikácia",
        vat_number: "Daňová identifikácia"
      }
    },
    companies: {
      header: {
        name: "Názov",
        code: "Kód",
        counry: "Štát",
        created: "Vytvorené"
      }
    },
    deviceConnections: {
      header: {
        numeric_plate: "ŠPZ",
        device: "Zariadenie",
        ip: "IP",
        connected_from: "Pripojené od",
        packets: "Počet paketov",
        measures: "Počet merania"
      }
    },
    apiConnections: {
      header: {
        user: "Užívateľ",
        type: "Typ",
        application: "Klient",
        ip: "IP",
        timestamp: "Posledná komunikácia",
        company: "Kód firmy"
      }
    }
  },

  component: {
    login: {
      username: "Užívateľské meno",
      password: "Heslo",
      permanent: "Trvalé prihlásenie",
      confirm: "Prihlásiť"
    },
    vehicle_field: {
      title: "Vozidlo"
    },
    vehicles_field: {
      title: "Vozidlo(a)"
    },
    person_field: {
      title: "Osoba"
    },
    subject_field: {
      title: "Organizácia",
      new: "Vytvořit novou organizaci"
    },
    period_field: {
      title: "Obdobie",
      from: "Od",
      to: "Do",
      time: "Čas",
      "day-current": "Aktuálny deň",
      "day-previous": "Predchádzajúcí deň",
      "day-one": "Deň",
      "day-range": "Viac dní",
      "day-rangetime": "Viac dní (s časom)",
      "month-current": "Aktuálny mesiac",
      "month-previous": "Predchádzajúci mesiac",
      "month-one": "Mesiac",
      "month-range": "Viac mesiacov"
    },
    items_selection: {
      "toggle_fullsreen": "Roztáhnout/zmenšít seznam",
      "inverse_toggle": "Inverzní výber",
      "inverse_on": "zapnuto",
      "inverse_off": "vypnuto"
    }
  },

  report: {
    close: "Zavrieť",
    panel_show: "Zobraziť panel",
    panel_hide: "Skryť panel",
    save_as_pdf: "Uložiť ako pdf",
    save_as_xlsx: "Uložiť ako excel",
    logbook: {
      title: "Kniha jázd",
      filename: "kniha_jázd",
      detailed: "Podrobný výpis",
      "day-summary": "Denný sumár",
      "week-summary": "Týždenný sumár",
      "border-crossing": "Priechody hranic"
    },
    performance: {
      title: "Výkon vozidla",
      filename: "výkon vozidla",
      detailed: "Podrobný výpis",
      "day-summary": "Denný sumár",
      "week-summary": "Týždenný sumár",
      "border-crossing": "Priechody hranic",
      "category-summary": "Sumár podľa rôznych kategórií"
    },
    "machine-performance": {
      title: "Výkon stroja",
      filename: "výkon_stroja",
      detailed: "Podrobný výpis",
      "day-summary": "Denný sumár",
      "week-summary": "Týždenný sumár",
      "border-crossing": "Priechody hranic"
    },
    "driver-performance": {
      title: "Výkon vodiča",
      filename: "výkon_vodiča",
      detailed: "Podrobný výpis",
      "day-summary": "Denný sumár",
      "week-summary": "Týždenný sumár",
      "border-crossing": "Priechody hranic",
      "vehicle-summary": "Sumár vozidla",
      "show-note": "Zobraziť poznámku"
    },
    temperature: {
      title: "Teplota",
      filename: "teplota",
      granularity: "Zoskupovať",
      "remove-empty-rows": "Nezobrazovať prázdne riadky",
      granularities: {
        none: "nezoskupovať",
        m15: "po 15 minutách",
        m30: "po 30 minutách",
        m60: "po hodinách"
      }
    },
    tanks: {
      title: "Stav nadrží",
      filename: "stav_nadrží",
      detailed: "Podrobný výpis",
      "day-summary": "Denný sumár",
      "week-summary": "Týdenní sumář",
      "border-crossing": "Priechody hraníc"
    },
    tachograph: {
      title: "Tachograf",
      filename: "tachograf",
      weeks_scope: "Týždenná štatistika",
      days_scope: "Denná štatistika",
      scopes: {
        none: "Nezobrazovať",
        base: "Sumárna informácia",
        graph: "Grafy",
        detail: "Podrobný výpis",
        all: "Všetko"
      }
    },
    "travel-expenses": {
      title: "Cestovné náklady",
      filename: "cestovné_náklady",
      ride_border: "Od/do z jázd",
      home_as_abroad: "Domáce cesty ako zahraničné",
      simplified: "Zjednodušený formulár",
      more_params: "Ostatné parametre"
    },
    "vehicles-summary": {
      title: "Štatistika vozidiel",
      filename: "štatistika_vozidiel"
    },
    "countries-summary": {
      title: "Štatistika podle států",
      filename: "štatistika_podle_statu"
    },
    "abroad-summary": {
      title: "Štatistika doma/zahraničí",
      filename: "štatistika_doma_zahraničí"
    },
    "planned-services": {
      title: "Najbližší plán údržby",
      filename: "najbližší_plán_údržby"
    },
    "refuelings": {
      title: "Tankovanie",
      filename: "tankovanie"
    },
    "companies-summary": {
      title: "Prehľad spoločností",
      filename: "prehľad_spoločností"
    }
  },

  dialog: {
    company_selection: {
      title: "Výber firmy",
      filter: "filter"
    },
    vehicle_selection: {
      title: "Výber vozidla",
      filter: "filter"
    },
    groupset_selection: {
      title: "Výběr skupiny",
      filter: "filter",
      view_all: "Zobrazit vše"
    },
    find_vehicles: {
      title: "Hľadať vozidlo",
      text: "text (min. 3 znaky)"
    },
    identification: {
      title: "Identifikácia",
      add: "Pridať",
      type: "Typ",
      code: "Jednoznačný kód"
    },
    tank: {
      title: "Nádrž",
      store: "Uložiť",
      remove: "Zmazať",
      vehicle_tank_type: "Typ nádrže",
      tank_calc_method: "Spôsob získavania stavu",
      fuel_type: "Palivo",
      capacity: "Kapacita nádrže v litroch",
      start_state: "Počiatočný stav v litroch",
      need_condition: "Vyžaduje vhodné podminky pre meranie (vozidlo stojí)",
      liter_factor: "Faktor",
      sensor_nvalues: "Prevodná tabuľka pre senzor"
    },
    contact: {
      title: "Kontakt",
      store: "Uložiť",
      remove: "Zmazať",
      type: "Typ kontaktu",
      phone: "Telefon",
      email: "Email",
      street: "Ulica",
      house_number: "Číslo domu",
      city: "Obec",
      postal_code: "PSČ",
      country: "Krajina",
      note: "Poznámka",
      registered: "Registrovaný kontakt (napr. štatutárna adresa)",
      billing: "Fakturačný kontakt",
      communication: "Kontakt pre komunikáciu"
    },
    vehicle_log: {
      title: "Log",
      log_date: "Vyberte dátum"
    },
    not_found: {
      title: "Neplatná stránka"
    },
    confirm: {
      button_cancel: "Zavrieť",
      button_ok: "OK",
      button_delete: "Vymazať"
    },
    travel_expenses: {
      tab: {
        base: "Parametre",
        days: "Individuálne dni"
      },
      store: "Použiť",
      place_from: "Miesto začatia cesty",
      place_to: "Miesto konca cesty",
      purpose: "Dôvod a cieľ cesty",
      deposit: "Záloha (v domácej mene)",
      deposit_date: "Záloha vyplatená dňa",
      breakfast: "raňajky",
      lunch: "obed",
      dinner: "večera"
    },
    refueling: {
      tabs: {
        data: "Vloženie dát",
        summary: "Súhrn"
      },
      panels: {
        file: "Zo súboru",
        handy: "Manuálne vloženie"
      },
      table: {
        "date_time": "Dátum",
        "numeric_plate": "SPZ",
        "fuel": "Palivo",
        "quantity": "Množstvo",
        "amount": "Čiastka",
        "place": "Miesto"
      },
      menu: {
        select: "Zobraziť tankovanie",
        doc_add: "Pridať doklad",
        doc_update: "Upraviť doklad",
        doc_delete: "Zmazať doklad"
      },
      parse: "Načítať",
      store: "Vložiť",
      add: "Pridať",
      update: "Upraviť",
      title_document: "Dokladované tankovanie",
      vehicle: "Vozidlo",
      place: "Miesto tankovania",
      date_time: "Dátum a čas",
      fuel: "Palivo",
      full: "do plna",
      amount: "Čiastka",
      quantity: "Množstvo v litrech",
      file: "Súboru pre import",
      messages: {
        result: "Vložený počet tankování"
      }
    },
    update_vehicle: {
      title: "Úprava prevádzkových parametrov vozidla",
      store: "Uložiť"
    },
    update_ride: {
      title: "Úprava jazdy",
      store: "Uložiť",
      ride_type: "Typ jazdy",
      driver: "Vodič",
      note: "Krátká poznámka",
      stop_km: "Zarážka tachometra",
      stop_eh: "Zarážka motohodín",
      stop_fix: "zarážka nastavená"
    },
    service_plan: {
      title: "Plán údržby",
      store: "Uložiť",
      type_code: "Druh plánu",
      name: "Upresnenie plánu (voliteľné)",
      date: "Dátum budúcej údržby",
      period: "Opakovať po (formát {n}r {n}m {n}d)",
      km: "Stav tachometra pre budúcu údržbu",
      repeated_km: "Opakovať po (v km)",
      eh: "Stav motohodín pre budúcu údržbu",
      repeated_eh: "Opakovať po (v mh)",
      active: "Plán údržby je aktívny"
    },
    service: {
      title: "Údržba",
      store: "Uložiť",
      plan: "Plán údržby",
      type_code: "Druh údržby",
      name: "Upresnenie údržby (voliteľné)",
      date: "Dátum údržby",
      km: "Stav tachometra",
      eh: "Stav motohodín",
      note: "Poznámka"
    },
    "subject-search": {
      title: "Vyhľadávanie spoločností",
      name: "Názov",
      id: "Identifikácia (IČ)",
      vat_number: "Daňová identifikácia (DIČ)",
      address: "Štatutárna adresa",
      update: "Použiť zaškrtnuté",
      error: {
        not_found: "Spoločnosť nenájdená",
        gateway_timeout: "Služba pre daný štát je nedostupná",
        country_not_supported: "Vyhľadávanie spoločností pre tento štát nie je podporovaný",
        invalid_parameter: "Identifikácia má neplatný formát"
      }
    }
  },

  error: {
    vehicle_fail: "Vozidlo nekomunikuje",
    optimistic_lock: "Záznam bol behom vašej úpravy zmenený. Je nutné ho znovu upraviť."
  },

  enum: {
    ride_type: {
      "bussines": "služobná jazda",
      "private": "súkromná jazda",
      "refueling": "tankovanie",
      "fuelloss": "úbytok paliva",
      "un-loading": "nakládka/vykládka",
      "loading": "nakladanie",
      "unloading": "vykladanie"
    },
    vehicle_state: {
      "active": "aktívny",
      "hidden": "skrytý",
      "removed": "vymazaný"
    },
    ride_state: {
      "finished": "ukončená",
      "unfinished": "prebiehajúca"
    },
    vehicle_type: {
      "personal": "osobné vozidlo",
      "truck": "nákladné vozidlo",
      "tractor": "traktor",
      "trailer": "príves",
      "semitrailer": "náves",
      "special": "špeciálne",
      "machine": "stroj"
    },
    vehicle_category: {
      "M1": "M1",
      "N1": "N1"
    },
    vehicle_norm: {
      "euro1": "Euro 1",
      "euro2": "Euro 2",
      "euro3": "Euro 3",
      "euro4": "Euro 4",
      "euro5": "Euro 5",
      "euro6": "Euro 6",
      "euro7": "Euro 7"
    },
    vehicle_motiondetection: {
      "none": "nedetekovať",
      "speed": "od rýchlosti",
      "motion": "od pohybu"
    },
    device_type: {
      "bce": "BCE",
      "bceiotm": "BCE/IOTM"
    },
    vehicle_tank_type: {
      "main": "Hlavná nádrž",
      "heating": "Kúrenie"
    },
    tank_calc_method: {
      "none": "Nezískavajú sa",
      "sensor": "Senzor",
      "liter": "CAN v litroch",
      "percent": "CAN v percentách",
      "manual": "Manuálne počítanie"
    },
    fuel_type: {
      "benzin95": "Natural 95",
      "benzin98": "Natural 98",
      "diesel": "Nafta",
      "biodiesel": "Bio nafta",
      "gas": "Plyn"
    },
    tachograph_activity: {
      "0": "Odpočinok/prestávka",
      "1": "Pohotovosť",
      "2": "Práca",
      "3": "Jazda",
      "4": "Chyba",
      "5": "Bez karty"
    },
    person_access: {
      "normal": "bežný užívateľ",
      "superuser": "super užívateľ",
      "collective": "hromadný prístup"
    },
    person_type_ids: {
      "dallas": "dallas/RFID",
      "tachograph": "tachograf"
    },
    parameters: {
      "motor_on": "motor",
      "panic": "panic",
      "cargo_door": "dvere nakladového priestoru"
    },
    service_type: {
      own: "vlastné",
      mot: "STK",
      oil_change: "výmena oleja",
      oil_refill: "doplnenie oleja",
      tacho_check: "kontrola tachografu",
      highway_stamp: "ďalničná známka",
      warranty_inspection: "garančná prehliadka"
    },
    contact_type: {
      address: "adresa",
      phone: "telefon",
      email: "email"
    }
  },

  param_names: {
    true: {
      "motor_on": "naštartovaný",
      "panic": "aktívny",
      "cargo_door": "otvorené"
    },
    false: {
      "motor_on": "vyplý",
      "panic": "deaktivovaný",
      "cargo_door": "zatvorené"
    }
  },

  roles: {
    "superuser": "superužívateľ",
    "admin": "administrátor",
    "dispatcher": "dispečer",
    "driver": "vodič",
    "viewall": "vidí vše"
  },

  // importy z jiných knihoven
  $vuetify: sk_vuetify,
  validation: sk_vee
};

lang.validation.messages.decimal = "Pole {_field_} musí byť desatinné číslo a počet povolených číslic za desatinnou čiarkou je {decimals}";
lang.validation.messages.sensor_nvalues = "Pole {_field_} musí byť vo formáte: n=číslo;...";

export default lang;